import { render } from "./AddLabelsWithoutClick.vue?vue&type=template&id=2be2453a&scoped=true"
import script from "./AddLabelsWithoutClick.vue?vue&type=script&lang=js"
export * from "./AddLabelsWithoutClick.vue?vue&type=script&lang=js"

import "./AddLabelsWithoutClick.vue?vue&type=style&index=0&id=2be2453a&scoped=true&lang=css"

import exportComponent from "E:\\Dev\\Univ\\vueQuizzly\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2be2453a"]])

export default __exports__